import React, { useContext } from 'react';
import styled from 'styled-components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { FlexSpace, card, LinkTab, LinksContainer, PromptClick, CircleIcon } from '@ubeya/shared-web/components';
import { ReactComponent as DeleteIcon } from '@ubeya/shared-web/assets/delete.svg';
import { TabTypes } from 'crm/constants';

const Wrapper = styled(FlexSpace)`
  ${card};
  padding: 0 30px;
  z-index: 3;
`;

const ClientCardTabs = ({ activeTab, setActiveTab, deleteClient, handleClose, tabs }) => {
  const { t } = useContext(ConfigContext);

  return (
    <Wrapper>
      <LinksContainer>
        {(tabs || []).map((tab) => (
          <LinkTab key={tab} isActive={activeTab === tab} onClick={() => setActiveTab(tab)}>
            {t(tab)}
          </LinkTab>
        ))}
      </LinksContainer>

      {activeTab === TabTypes.SETTINGS && (
        <PromptClick
          body={t('areYouSureDeleteClient')}
          confirmText="delete"
          onClick={() => deleteClient({ onSuccess: handleClose })}>
          <CircleIcon icon={DeleteIcon} tooltip={t('delete')} />
        </PromptClick>
      )}
    </Wrapper>
  );
};

export default ClientCardTabs;
